import React from 'react';
import { Clock, Users } from 'lucide-react';
import { useCountdown } from '../lib/countdown';
const SEATS_LEFT = 50;
export function UrgencyBanner() {
  const {
    minutes,
    seconds
  } = useCountdown();
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="inline-flex flex-col sm:flex-row items-stretch rounded-2xl overflow-hidden border border-sage-light/40 shadow-sm bg-white mb-4" data-id="element-284">
      <div className="flex items-center px-4 py-2.5 bg-terracotta text-white" data-id="element-285">
        <Clock className="w-4 h-4 mr-2 shrink-0" data-id="element-286" />
        <span className="text-xs font-bold uppercase tracking-wider mr-3 flash-white" data-id="element-287">
          Oferta termina en
        </span>
        <div className="flex items-center font-mono font-bold text-lg tabular-nums flash-white" data-id="element-288">
          <span data-id="element-289">{pad(minutes)}</span>
          <span className="mx-1" data-id="element-290">:</span>
          <span data-id="element-291">{pad(seconds)}</span>
        </div>
      </div>
      <div className="flex items-center px-4 py-2.5 bg-cream-light" data-id="element-292">
        <Users className="w-4 h-4 mr-2 text-sage-dark shrink-0" data-id="element-293" />
        <span className="text-sm font-medium text-gray-800" data-id="element-294">
          Solo{' '}
          <span className="font-bold flash-terracotta" data-id="element-295">{SEATS_LEFT} cupos</span>{' '}
          disponibles
        </span>
      </div>
    </div>;
}